import { render, staticRenderFns } from "./CeoExternalPeople.vue?vue&type=template&id=5d6f3e84&scoped=true&"
import script from "./CeoExternalPeople.vue?vue&type=script&lang=js&"
export * from "./CeoExternalPeople.vue?vue&type=script&lang=js&"
import style0 from "./CeoExternalPeople.vue?vue&type=style&index=0&id=5d6f3e84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6f3e84",
  null
  
)

export default component.exports